'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BaseMenu = require('../BaseMenu');

var _BaseMenu2 = _interopRequireDefault(_BaseMenu);

var _BaseMenuSection = require('../BaseMenuSection');

var _BaseMenuSection2 = _interopRequireDefault(_BaseMenuSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewsMenu = function NewsMenu(_ref) {
  var links = _ref.links,
      onClickLink = _ref.onClickLink;
  return _react2.default.createElement(
    _BaseMenu2.default,
    null,
    _react2.default.createElement(_BaseMenuSection2.default, {
      links: links,
      onClick: function onClick(properties) {
        return onClickLink({
          name: 'Clicked Main Nav',
          properties: (0, _extends3.default)({}, properties, {
            tabName: 'News',
            clickEndLocation: 'News'
          })
        }, true);
      }
    })
  );
};

NewsMenu.propTypes = {
  links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    display: _propTypes2.default.string,
    href: _propTypes2.default.string
  })).isRequired,
  onClickLink: _propTypes2.default.func
};

NewsMenu.defaultProps = {
  onClickLink: null
};

exports.default = NewsMenu;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/NewsMenu/NewsMenu.js
// module id = 308
// module chunks = 0